import sortBy from 'lodash/sortBy';

const hasValidPenalty = (cancellationField) => cancellationField && parseInt(cancellationField) > 0;

export const resolveFirstCancellationWindowWithPenalty = (cancellationWindows) => {
  const sortedWindows = sortBy(cancellationWindows || [], ({ startTime }) => new Date(startTime));
  return sortedWindows.find(
    ({ nights, percentage, fixedCost }) => hasValidPenalty(fixedCost) || hasValidPenalty(percentage) || hasValidPenalty(nights),
  );
};
